import { render, staticRenderFns } from "./VisitsFormPopup.vue?vue&type=template&id=68a1b025&"
import script from "./VisitsFormPopup.vue?vue&type=script&lang=js&"
export * from "./VisitsFormPopup.vue?vue&type=script&lang=js&"
import style0 from "./VisitsFormPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports